module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0zm7.414 23.414c-.39.39-.902.586-1.414.586s-1.024-.196-1.414-.586L14 16.828V8a2 2 0 1 1 4 0v7.172l5.414 5.414a1.998 1.998 0 0 1 0 2.828z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/clock-1.js
// module id = 1067
// module chunks = 14